import { render, staticRenderFns } from "./memberCouponUsedRecord.vue?vue&type=template&id=ab060642&scoped=true"
import script from "./memberCouponUsedRecord.vue?vue&type=script&lang=ts"
export * from "./memberCouponUsedRecord.vue?vue&type=script&lang=ts"
import style0 from "./memberCouponUsedRecord.vue?vue&type=style&index=0&id=ab060642&prod&scoped=true&lang=stylus"
import style1 from "./memberCouponUsedRecord.vue?vue&type=style&index=1&id=ab060642&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab060642",
  null
  
)

export default component.exports